import { userClient } from './auth'

/** 적립금 이력조회 */
export async function getAccumulations(type: string) {
  const firstReq = await userClient.get(`/profile/accumulations?accumulationReason=${type}`)
  return await userClient.get(
    `/profile/accumulations?accumulationReason=${type}&pageSize=${
      firstReq.data.totalCount ? firstReq.data.totalCount : 1
    }`
  )
}

/** 적립금 요약조회 */
export async function getAccumulationsSummary(date: any) {
  return await userClient.get(`/profile/accumulations/summary?expireEndYmdt=${date}`)
}

/** 만료예정 적립금 조회 */
export async function getAccumulationsExpire(startDate: string, endDate: string) {
  if (!startDate || !endDate) await userClient.get('/profile/accumulations/expiration')
  return await userClient.get(`/profile/accumulations/expiration?startYmdt=${startDate}&endYmdt=${endDate}`)
}
